var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { query } from 'lit/decorators.js';
import { property } from 'lit/decorators.js';
import { booleanDecoder, stringDecoder, PICBase, customElement } from '../Internals';
let PICUploadModal = class PICUploadModal extends PICBase {
    constructor() {
        super(...arguments);
        this.isHidden_ = true;
        this.multiple_ = false;
        this.fileTypes_ = '';
        this.noteKey_ = '';
        this.succesEvent_ = '';
    }
    get isHidden() {
        if (this.modal) {
            return this.modal.isHidden;
        }
        return this.isHidden_;
    }
    set isHidden(isHidden) {
        this.isHidden_ = isHidden;
        if (this.modal) {
            this.modal.isHidden = isHidden;
        }
        this.requestUpdate();
    }
    static get styles() {
        const defaultStyle = css `
            .bodycontainer{
                padding-top: 2rem;
            }
            .content{
                display: flex;
                align-items: center;
                justify-content: center;
            }
        `;
        return css `
          ${super.styles}
          ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return html `
            <pic-modal .isNew=${true} .isHidden=${this.isHidden} .title_=${'Upload'} width='584px' height='700px'>
                <div class="bodycontainer" slot="slot-modal-body">
                    <div class="content">
                        <pic-upload 
                            .multiple_=${this.multiple_}
                            filetypes=${this.fileTypes_}
                            notekey=${this.noteKey_}
                            user=${this.user_}
                            succesevent=${this.succesEvent_}>
                    </pic-upload>
                </div>
            </div>  
                <!--footer here -->
            </pic-modal>
        `;
    }
};
__decorate([
    property({ converter: booleanDecoder, attribute: 'multiple' })
], PICUploadModal.prototype, "multiple_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'filetypes' })
], PICUploadModal.prototype, "fileTypes_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'notekey' })
], PICUploadModal.prototype, "noteKey_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'user' })
], PICUploadModal.prototype, "user_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'succesevent' })
], PICUploadModal.prototype, "succesEvent_", void 0);
__decorate([
    query('pic-modal')
], PICUploadModal.prototype, "modal", void 0);
PICUploadModal = __decorate([
    customElement('pic-uploadmodal')
], PICUploadModal);
export { PICUploadModal };
//# sourceMappingURL=PICUploadModal.js.map